import './style.scss'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { FixedContainer, GridContainer, Icon, CustomContainer, AppText, AppSpan, Circle, FlexRow, FlexColumn } from "src/style"
import {OnboardingSideData} from 'src/model'
import SideContentIcon from 'src/assets/svg/side-content-d3-icon'

export const OnboardingSideContentD2 = () => {
    const navigate = useNavigate()
    const {info: {onboardingSideInfo, institutionData}} = useContext(AppInfoContext)
    const [contents, setContents] = useState<Array<OnboardingSideData>>([])
    const [currentPoint,setCurrentPoint] = useState(0)
    const [appLogo, setAppLogo] = useState('')

    useEffect(() => {
        if (institutionData) setAppLogo(institutionData.logo)
    }, [institutionData?.logo])

    useEffect(() => {
        let timer: any = ''
        if (onboardingSideInfo?.length) {
            timer = window.setTimeout(async () => {
                setCurrentPoint(currentPoint != (onboardingSideInfo.length - 1) ? currentPoint + 1 : 0)
            }, 10000)
        }
 
        return () => { clearTimeout(timer) }
     }, [currentPoint, onboardingSideInfo])
     
    useEffect(() => {
        if (onboardingSideInfo?.length) setContents(onboardingSideInfo)
    }, [onboardingSideInfo])

    return (
        <>
            <FixedContainer 
                top='0' left='0' 
                width='100' sizeUnit='%' 
                zIndex='3'
            >
                <GridContainer
                    height='13' bgColor='#E1FFFD'
                >
                    <CustomContainer width='15.4' height='4' bottomMargin='1'>
                        { appLogo ? <Icon 
                            src={appLogo} 
                            className='app-logo-icon' 
                            noResize
                            onClick={() => navigate('/login')}
                        /> : null }
                    </CustomContainer>
                </GridContainer>
            </FixedContainer>
            <FixedContainer 
                height='full' top='13' left='0'
                zIndex='3' bgColor='#ffffff'
                className='onboarding-side-content-body'
                style={{overflow: 'hidden'}}
            >
                <CustomContainer height='100' hUnit='%'>
                    <FlexColumn 
                        overflow='auto' minHeight='100'
                        mnHUnit='%' topMargin='-5'
                        width='48' padding='3' leftPadding='6'
                        className="onboarding-side-content-container-d2"
                        style={{borderRight: '1.5px solid #EEF0F2'}}
                    >
                        <CustomContainer>
                            <SideContentIcon className='icon-component' />
                            <CustomContainer topMargin='3' width='35.6' className='ad-slider-container'>
                                {
                                    contents?.map((item: any, index: number) => {
                                        return (
                                            currentPoint === index &&
                                            <CustomContainer data-aos="slide-left" key={index}>
                                                <AppText 
                                                    textSize='3' fontWeight='700' color='#212121' 
                                                    fontFamily='Gilmer-Bold' bottomMargin="1"
                                                >
                                                    {item.title}
                                                </AppText>
                                                <AppSpan color="#212121">
                                                    {item.body}
                                                </AppSpan>
                                            </CustomContainer>
                                        )
                                    })
                                }
                                <FlexRow gap="1" topMargin="1.5">
                                    {
                                        Array.from(Array(contents?.length).keys()).map((item: number) => {
                                            return (
                                                <Circle 
                                                    size="0.5" bgColor={currentPoint === item ? '#0D968F' : "#212121"} key={item}
                                                    onClick={() => setCurrentPoint(item)}
                                                />
                                            )
                                        })
                                    }
                                </FlexRow>
                            </CustomContainer>
                        </CustomContainer>
                    </FlexColumn>
                </CustomContainer>
            </FixedContainer>
        </>
    )
}